module.exports = __webpack_public_path__ + "static/img/th-crads-technical2-09.88af58c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnails/th-crads-technical2-09.png
// module id = o49x
// module chunks = 1